
// import axios from '@/classes/myAxios'
import axios from 'axios'


const myAxios = axios.create({
baseURL: 'http://localhost:3000'
});

// console.log(`process:${process.env.NODE_ENV}`)

// if(process.env.NODE_ENV == 'development')

// const exportedAxios = process.env.NODE_ENV == 'development' ? myAxios: axios;

let exportAxios;

if(process.env.NODE_ENV == 'development'){

    // console.log(`export myaxios`)
    exportAxios = myAxios;
}else{

    // console.log(`export axios`)

    exportAxios = axios
}

export default exportAxios;
